import { render, staticRenderFns } from "./CustomerOpenTickets.vue?vue&type=template&id=1511fb53&scoped=true"
import script from "./CustomerOpenTickets.vue?vue&type=script&lang=js"
export * from "./CustomerOpenTickets.vue?vue&type=script&lang=js"
import style0 from "./CustomerOpenTickets.vue?vue&type=style&index=0&id=1511fb53&prod&lang=sass&scoped=true"
import style1 from "./CustomerOpenTickets.vue?vue&type=style&index=1&id=1511fb53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1511fb53",
  null
  
)

export default component.exports